<common-navigation></common-navigation>

<div class="container-fluid">
    <div class="row no-gutter">
        <div class="col-md-6 col-lg-4">
            <div class="sign-in default-box long-form d-flex align-items-center">
                <div class="container">
                    <div class="row">
                        <div class="col-md-4 col-lg-4 col-xl-4 mx-auto side-nav" id="sign-in-sidenav">
                            <!-- Error Message -->
                            <div class="alert alert-warning alert-dismissible fade show" role="alert" *ngIf="error">
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="error = !error">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                                {{ errorMsg }}
                            </div>

                            <!-- Account Activation Message -->
                            <div class="alert alert-info alert-warning fade show" role="alert" *ngIf="showAccountActivation">
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="showAccountActivation = !showAccountActivation">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                                <strong>Your account is not activated.</strong> <br>
                                Check your email for the activation link. <br><br>
                                If you haven't received an email yet, <br>
                                <a (click)="resendActivationLink()" class="resendLink">click here to resend it.</a>
                            </div>

                            <!-- Account Suspended Message -->
                            <div class="alert alert-info alert-warning fade show" role="alert" *ngIf="showAccountSuspended">
                              <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="showAccountSuspended = !showAccountSuspended">
                                <span aria-hidden="true">&times;</span>
                              </button>
                              <strong>Your account is suspended</strong>
                            </div>

                            <!-- Voucher invalid Message -->
                            <div class="alert alert-info alert-warning fade show" role="alert" *ngIf="showInvalidVoucher">
                              <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="showInvalidVoucher = !showInvalidVoucher">
                                <span aria-hidden="true">&times;</span>
                              </button>
                              <strong>Invalid voucher code</strong>
                            </div>

                            <!-- Success Account Activation Message -->
                            <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="showActivationSuccess">
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="showActivationSuccess = !showActivationSuccess">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                                New Activation link was successfully sent to your email.
                            </div>

                            <h3 class="display-4 box-title">Sign In</h3> <br>
                              <form [formGroup]="signInForm" (ngSubmit)="onSubmit()">
                                <div *ngIf="!showVoucherExpired">
                                  <p >Don't have an account? <a routerLink="/sign-up">Sign Up</a></p>
                                  <div class="md-input">
                                      <input
                                          class="md-form-control"
                                          required
                                          type="email"
                                          formControlName="email"
                                          [ngClass]="{'error': (submitted && signInForm.invalid && f.email.invalid) || (f.email.dirty && f.email.invalid)}"
                                      >
                                      <span class="highlight"></span>
                                      <span class="bar"></span>
                                      <label>Email</label>
                                  </div>
                                  <div class="md-input password">
                                      <input
                                          class="md-form-control"
                                          required
                                          type="password"
                                          formControlName="password"
                                          id="password-input"
                                          [ngClass]="{'error': (submitted && signInForm.invalid && f.password.invalid) || (f.password.dirty && f.password.invalid)}"
                                      >
                                      <span class="highlight"></span>
                                      <span class="bar"></span>
                                      <label>Password</label>
                                      <span class="show-password" (click)="showPassword()">
                                          <i class="fa fa-eye-slash" id="show-password-icon"></i>
                                      </span>
                                  </div>
                                  <div class="forgot-password">
                                      <a routerLink="/forgot-password">Forgot Password?</a>
                                  </div>

                                  <button type="submit" class="btn btn-primary btn-block btn-submit">
                                      Sign In
                                  </button>
                                </div>
                              </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6 col-lg-8 d-none d-lg-flex default-box bg-image"></div>
    </div>

    <!-- Modal Loader -->
    <modal-loader [modalText]="modalText"></modal-loader>

</div>
